onComplete(function () {

	const items = document.querySelectorAll(".amy-block-top");
	const itemsText = document.querySelectorAll(".amy-block-wrap");

	const readMoreElements = document.querySelectorAll(".amy-read-more-button");
	const closeButtonElements = document.querySelectorAll(".amy-extra-text");

	const readMoreInner = readMoreElements.length > 0 ? readMoreElements[0].getAttribute('data-amy-read-more') : 'Lees meer';
	const closeButtonInner = closeButtonElements.length > 0 ? closeButtonElements[0].getAttribute('data-amy-close') : 'Sluit';

	let itemsTextHeights = [];
	itemsText.forEach(item => {
		itemsTextHeights.push(item.clientHeight);
	});

	items.forEach((item, i) => {
		itemsText[i].style.height = '0px';
		item.addEventListener('click', () => {
			if (item.classList.contains('active')) {
				item.classList.remove("active");
				itemsText[i].style.height = '0px';
				item.querySelector(".amy-extra-text").innerHTML = readMoreInner;
			} else {
				item.classList.add("active");
				itemsText[i].style.height = itemsTextHeights[i] + 'px';
				item.querySelector(".amy-extra-text").innerHTML = closeButtonInner;
			}
		});
	});



	// if (document.querySelector('.content-subtemplate-content')) {

	// 	const breadCrumb = document.querySelector('.breadcrumb-wrap');
	// 	const breadCrumbHeight = breadCrumb.clientHeight;

	// 	const heading = document.querySelector('h1');
	// 	const headingHeight = heading.clientHeight;

	// 	const contentHeader = document.querySelector('.header-image img')
	// 	contentHeader.style.height = breadCrumbHeight + headingHeight + 16 + "px";

	// }

});